import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { refreshSessionInfo, RefreshSessionInfoAction } from '../actions/RefreshSessionInfoAction';


export function* rootWalkMeSaga(): SagaIterator {
  yield takeLatest(refreshSessionInfo, handleRefreshSessionInfo);
}

export function* handleRefreshSessionInfo(action: RefreshSessionInfoAction): SagaIterator {
  if (FeatureFlags.walkMeOnVpcDemoDepotEnabled) {
    const walkMeId = 'walkMeIdSnippetForDemoSite';
    let walkMeElement = document.getElementById(walkMeId);
    // ensure we dont add it twice
    if (walkMeElement == null) {
      let walkMe = document.createElement('script');
      walkMe.type = 'text/javascript';
      walkMe.async = true;
      walkMe.src = 'https://cdn.walkme.com/users/af5482dae260468fa428eb917340f14a/walkme_af5482dae260468fa428eb917340f14a_https.js';
      walkMe.id = walkMeId;
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(walkMe, s);
      window._walkmeConfig = {smartLoad:true};
    }
  }
}
